export enum DocumentStatus {
  New = 'New',
  InSigning = 'InSigning',
  Cancelled = 'Cancelled',
  Signed = 'Signed',
  InReview = 'InReview',
  Reviewed = 'Reviewed',
  Deleted = 'Deleted',
  Rejected = 'Rejected'
}